const defaultPaths = {
  primaryCalls: [
    { key: 'SET_FUND_INFO', value: 'fund-info' },
    { key: 'SET_VOLATILITY_RETURN', value: 'volatilityReturn', sendAssetClass: true },
    { key: 'SET_GEOGRAPHIC_BREAKDOWN', value: 'geographicBreakdown' },
    { key: 'SET_FEES', value: 'fee' },
    { key: 'SET_EXPENSES', value: 'expenses' },
    { key: 'SET_UNDERLYING_FUNDS', value: 'underlyingFunds' },
    //HOLDINGS
    { key: 'SET_BONDS_BREAKDOWN', value: 'holdings/bonds-breakdown' },
    { key: 'SET_EQUITIES_BREAKDOWN', value: 'holdings/equities-breakdown' },
    { key: 'SET_GEOGRAPHY_INVESTING', value: 'holdings/new-geography-investing' },
    //RATINGS-RISK
    { key: 'SET_AVG_LIFE', value: 'ratings-risk/average-life' },
    { key: 'SET_MSTAR_RATINGS', value: 'ratings-risk/mstar-ratings' },
    { key: 'SET_RISK_MEASURES', value: 'ratings-risk/risk-measures' },
    { key: 'SET_QUALITY_SUMMARY', value: 'ratings-risk/quality-summary' },
    //RETURNS
    { key: 'SET_RETURNS', value: 'returns-module', sendIndexId: true },
    { key: 'SET_PORTFOLIO', value: 'returns/portfolio-managers' },
    //SUMMARY
    { key: 'SET_ASSET_MIX', value: 'summary/asset-mix' },
    { key: 'SET_MARKET_CAPITALIZATION', value: 'summary/market-capitalization' },
    { key: 'SET_DESCRIPTION', value: 'summary/description', mutationNeedsAudience: true },
    { key: 'SET_FUND_FACTS', value: 'summary/fund-facts' },
    { key: 'SET_FUND_STATISTICS', value: 'summary/fund-statistics' },
    { key: 'SET_HISTORICAL_DISTRIBUTIONS', value: 'historicalDistributions' },
    { key: 'SET_SUMMARY', value: 'summary/summary-module' },
    { key: 'SET_MSTAR_STYLE_BOX', value: 'summary/mstar-fixed-income' },
    { key: 'SET_MSTAR_OWNERSHIP', value: 'summary/mstar-ownership' },
    { key: 'SET_RETURNS_AT_NAV', value: 'summary/return-at-nav' },
    { key: 'SET_PURCHASE_RESTRICTIONS', value: 'summary/purchase-restrictions' },
    //Resources
    { key: 'SET_RESOURCES', value: 'resources' },
    //prices & distributions
    { key: 'SET_HISTORICAL_PRICES_MONTH', value: 'historicalprices' }
  ],
  secondaryCalls: [
    { key: 'SET_GROWTH_10K', value: 'returns/growth10k' }
  ]
};

const bondPaths = {
  primaryCalls: [
    { key: 'SET_QUALITY_SUMMARY', value: 'ratings-risk/quality-summary' },
    { key: 'SET_FUND_INFO', value: 'fund-info' },
    { key: 'SET_VOLATILITY_RETURN', value: 'volatilityReturn', sendAssetClass: true },
    { key: 'SET_GEOGRAPHIC_BREAKDOWN', value: 'geographicBreakdown' },
    { key: 'SET_FEES', value: 'fee' },
    { key: 'SET_EXPENSES', value: 'expenses' },
    { key: 'SET_UNDERLYING_FUNDS', value: 'underlyingFunds' },
    //HOLDINGS
    { key: 'SET_BONDS_BREAKDOWN', value: 'holdings/bonds-breakdown' },
    { key: 'SET_EQUITIES_BREAKDOWN', value: 'holdings/equities-breakdown' },
    { key: 'SET_GEOGRAPHY_INVESTING', value: 'holdings/new-geography-investing' },
    //RATINGS-RISK
    { key: 'SET_AVG_LIFE', value: 'ratings-risk/average-life' },
    { key: 'SET_MSTAR_RATINGS', value: 'ratings-risk/mstar-ratings' },
    { key: 'SET_RISK_MEASURES', value: 'ratings-risk/risk-measures' },
    { key: 'SET_QUALITY_SUMMARY', value: 'ratings-risk/quality-summary' },
    //RETURNS
    { key: 'SET_RETURNS', value: 'returns-module', sendIndexId: true },
    { key: 'SET_PORTFOLIO', value: 'returns/portfolio-managers' },
    //SUMMARY
    { key: 'SET_ASSET_MIX', value: 'summary/asset-mix' },
    { key: 'SET_MARKET_CAPITALIZATION', value: 'summary/market-capitalization' },
    { key: 'SET_DESCRIPTION', value: 'summary/description', mutationNeedsAudience: true },
    { key: 'SET_FUND_FACTS', value: 'summary/fund-facts' },
    { key: 'SET_FUND_STATISTICS', value: 'summary/fund-statistics' },
    { key: 'SET_HISTORICAL_DISTRIBUTIONS', value: 'historicalDistributions' },
    { key: 'SET_SUMMARY', value: 'summary/summary-module' },
    { key: 'SET_MSTAR_STYLE_BOX', value: 'summary/mstar-fixed-income' },
    { key: 'SET_RETURNS_AT_NAV', value: 'summary/return-at-nav' },
    { key: 'SET_PURCHASE_RESTRICTIONS', value: 'summary/purchase-restrictions' },
    //Resources
    { key: 'SET_RESOURCES', value: 'resources' },
    //prices & distributions
    { key: 'SET_HISTORICAL_PRICES_MONTH', value: 'historicalprices' }
  ],
  secondaryCalls: [{ key: 'SET_GROWTH_10K', value: 'returns/growth10k' }]
};

const quarterlyHoldingsPaths = {
  primaryCalls: [
    { key: 'SET_QUARTERLY_HOLDINGS', value: 'quarterly-holdings' },
    { key: 'SET_FUND_INFO', value: 'fund-info' }
  ],
  secondaryCalls: []
};

const managedRiskPaths = {
  primaryCalls: [
    { key: 'SET_QUALITY_SUMMARY', value: 'ratings-risk/quality-summary' },
    { key: 'SET_FUND_INFO', value: 'fund-info' },
    { key: 'SET_VOLATILITY_RETURN', value: 'volatilityReturn', sendAssetClass: true },
    { key: 'SET_GEOGRAPHIC_BREAKDOWN', value: 'geographicBreakdown' },
    { key: 'SET_FEES', value: 'fee' },
    { key: 'SET_EXPENSES', value: 'expenses' },
    { key: 'SET_UNDERLYING_FUNDS', value: 'underlyingFunds' },
    //HOLDINGS
    { key: 'SET_BONDS_BREAKDOWN', value: 'holdings/bonds-breakdown' },
    { key: 'SET_EQUITIES_BREAKDOWN', value: 'holdings/equities-breakdown' },
    { key: 'SET_GEOGRAPHY_INVESTING', value: 'holdings/new-geography-investing' },
    //RATINGS-RISK
    { key: 'SET_AVG_LIFE', value: 'ratings-risk/average-life' },
    { key: 'SET_MSTAR_RATINGS', value: 'ratings-risk/mstar-ratings' },
    { key: 'SET_RISK_MEASURES', value: 'ratings-risk/risk-measures' },
    { key: 'SET_QUALITY_SUMMARY', value: 'ratings-risk/quality-summary' },
    //RETURNS
    { key: 'SET_RETURNS', value: 'returns-module', sendIndexId: true },
    { key: 'SET_PORTFOLIO', value: 'returns/portfolio-managers' },
    //SUMMARY
    { key: 'SET_ASSET_MIX', value: 'summary/asset-mix' },
    { key: 'SET_MARKET_CAPITALIZATION', value: 'summary/market-capitalization' },
    { key: 'SET_DESCRIPTION', value: 'summary/description', mutationNeedsAudience: true },
    { key: 'SET_FUND_FACTS', value: 'summary/fund-facts' },
    { key: 'SET_FUND_STATISTICS', value: 'summary/fund-statistics' },
    { key: 'SET_HISTORICAL_DISTRIBUTIONS', value: 'historicalDistributions' },
    { key: 'SET_SUMMARY', value: 'summary/summary-module' },
    { key: 'SET_MSTAR_STYLE_BOX', value: 'summary/mstar-fixed-income' },
    { key: 'SET_RETURNS_AT_NAV', value: 'summary/return-at-nav' },
    { key: 'SET_PURCHASE_RESTRICTIONS', value: 'summary/purchase-restrictions' },
    //Resources
    { key: 'SET_RESOURCES', value: 'resources' },
    //prices & distributions
    { key: 'SET_HISTORICAL_PRICES_MONTH', value: 'historicalprices' }
  ],
  secondaryCalls: [{ key: 'SET_GROWTH_10K', value: 'returns/growth10k' }]
};

function getApiPaths(objective) {
  objective = objective.toLowerCase();
  const paths = {
    bond: bondPaths,
    default: defaultPaths,
    managedrisk: managedRiskPaths,
    quarterlyholdings: quarterlyHoldingsPaths
  };
  return paths[objective] || paths['default'];
}
export default {
  getApiPaths
};
